import { createSlice } from "@reduxjs/toolkit";
import { refundSettingsActionTypes } from "../utils";

const refundSettingsSlice = createSlice({
  name: "refundSettings",

  initialState: {
    incentive: {},
    thankYouHeading: null,
    thankYouDesc: null,
    thankYouCardHeading: null,
    keepTheItemAmount: null,
    keepTheItemAmountDesc: null,
    refundOriginalIncentive: null,
    refundCreditIncentive: null,
    incentiveMessage: null,
    refundOption: null,
    incentiveStatus: null,
    refundMethod: null,
    totalRefund: null,
    refundReviewRoute: null,
    refundAmountOnThankYouCard: null,
    enableIncentive: null,
    paymentAmount: null,
    paymentGatewayInfo: null,
    paymentLink: null,
    paymentRequired: null,
    razorPayPaymentID: null,
    iSCollectThroughRazorPay: null,
    collectPaymentThrough: null,
    razorPayObject: null,
  },

  reducers: {
    updateRefundSettingsDetails: (state, action) => {
      const { key, value } = action.payload;

      switch (key) {
        case refundSettingsActionTypes.UPDATE_INCENTIVE:
          state.incentive = value;
          break;
        case refundSettingsActionTypes.UPDATE_THANKYOU_HEADING:
          state.thankYouHeading = value;
          break;
        case refundSettingsActionTypes.UPDATE_THANKYOU_DESCRIPTION:
          state.thankYouDesc = value;
          break;
        case refundSettingsActionTypes.UPDATE_THANKYOU_CARD_HEADING:
          state.thankYouCardHeading = value;
          break;
        case refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT:
          state.keepTheItemAmount = value;
          break;
        case refundSettingsActionTypes.UPDATE_KEEP_THE_ITEM_AMOUNT_DESCRIPTION:
          state.keepTheItemAmountDesc = value;
          break;
        case refundSettingsActionTypes.UPDATE_REFUND_ORIGINAL_INCENTIVE:
          state.refundOriginalIncentive = value;
          break;
        case refundSettingsActionTypes.UPDATE_REFUND_CREDIT_INCENTIVE:
          state.refundCreditIncentive = value;
          break;
        case refundSettingsActionTypes.UPDATE_INCENTIVE_MESSAGE:
          state.incentiveMessage = value;
          break;
        case refundSettingsActionTypes.UPDATE_REFUND_OPTION:
          state.refundOption = value;
          break;
        case refundSettingsActionTypes.UPDATE_INCENTIVE_STATUS:
          state.incentiveStatus = value;
          break;
        case refundSettingsActionTypes.UPDATE_REFUND_METHOD:
          state.refundMethod = value;
          break;
        case refundSettingsActionTypes.UPDATE_TOTAL_REFUND:
          state.totalRefund = value;
          break;
        case refundSettingsActionTypes.UPDATE_REFUND_REVIEW_ROUTE:
          state.refundReviewRoute = value;
          break;
        case refundSettingsActionTypes.UPDATE_REFUND_AMOUNT_ON_THANK_YOU_CARD:
          state.refundAmountOnThankYouCard = value;
          break;
        case refundSettingsActionTypes.UPDATE_ENABLE_INCENTIVE:
          state.enableIncentive = value;
        case refundSettingsActionTypes.UPDATE_PAYMENT_AMOUNT:
          state.paymentAmount = value;
          break;
        case refundSettingsActionTypes.UPDATE_PAYMENT_GATEWAY_INFO:
          state.paymentGatewayInfo = value;
          break;
        case refundSettingsActionTypes.UPDATE_PAYMENT_LINK:
          state.paymentLink = value;
          break;
        case refundSettingsActionTypes.UPDATE_PAYMENT_REQUIRED:
          state.paymentRequired = value;
          break;
        case refundSettingsActionTypes.UPDATE_RAZORPAY_PAYMENT_ID:
          state.razorPayPaymentID = value;
          break;
        case refundSettingsActionTypes.UPDATE_COLLECT_FROM_RAZORPAY:
          state.iSCollectThroughRazorPay = value;
          break;
        case refundSettingsActionTypes.UPDATE_COLLECT_PAYMENT_THROUGH:
          state.collectPaymentThrough = value;
          break;
        case refundSettingsActionTypes.UPDATE_RAZORPAY_DETAILS:
          state.razorPayObject = value;
          break;
        default:
      }
    },
  },
});

// Export the slice
export { refundSettingsSlice };

// Export the actions
export const { updateRefundSettingsDetails } = refundSettingsSlice.actions;

// Export the reducer
export default refundSettingsSlice.reducer;
